import { Zap } from "lucide-react";
import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";
import { HIGHEST_PLAN_ID } from "@/config/plans";

interface NavUpgradeButtonProps {
  credits: number;
  planName: string;
  upgradeLabel: string;
  manageLabel: string;
  className?: string;
}

/**
 * Pricing CTA that always surfaces the user's current credit balance next to
 * the upgrade/manage label, so the token count is visible without opening the
 * credits popover. Shared by desktop and mobile navbars to keep them in sync.
 */
export function NavUpgradeButton({
  credits,
  planName,
  upgradeLabel,
  manageLabel,
  className,
}: NavUpgradeButtonProps) {
  const isHighestPlan = planName === HIGHEST_PLAN_ID;

  return (
    <Link to="/pricing" className={cn("relative group", className)}>
      <div className="absolute -inset-[1px] rounded-lg overflow-hidden">
        <div
          className="absolute -inset-[100%] animate-spin-slow"
          style={{
            background:
              "conic-gradient(from 0deg, transparent 0deg, transparent 270deg, hsl(var(--primary)) 270deg, hsl(var(--primary)) 360deg)",
          }}
        />
      </div>
      <button className="relative pl-2 pr-3 py-1.5 bg-background rounded-lg text-xs font-medium text-foreground hover:text-primary transition-colors flex items-center gap-2 border border-border/50">
        <span className="flex items-center gap-1 font-bold text-primary tabular-nums">
          <Zap className="w-3.5 h-3.5 fill-primary" />
          {credits}
        </span>
        <span className="h-3.5 w-px bg-border/70" aria-hidden="true" />
        <span>{isHighestPlan ? manageLabel : upgradeLabel}</span>
      </button>
    </Link>
  );
}
